import React from 'react';
import { Navigate } from 'react-router-dom';

interface ProtectedRouteProps {
  element: React.ReactElement;
}

const ProtectedRoute = ({ element }: ProtectedRouteProps) => {
  // sessionStorage 전역 상태에서 인증 상태를 확인
  const isAuthenticated = sessionStorage.getItem('isOTPVerified') === 'true';
  
  return isAuthenticated ? element : <Navigate to="/" replace />;
};

export default ProtectedRoute;